/**
 * The server sends `hints: []` when it has no hint. An empty list means the same as
 * none, but Chrome 155 left such a request waiting forever (seen with its virtual
 * authenticator, 16 October), so an empty list is not passed on.
 */
export function withoutEmptyHints<T extends object>(options: T): T {
  const { hints, ...rest } = options as T & { hints?: unknown };
  return Array.isArray(hints) && hints.length === 0 ? rest as T : options;
}
